import { Center, Image, Text } from '@chakra-ui/react';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';

import { GetEpAgreementWallContextQuery } from '../../graphql/queries/getEpAgreementWallContext.gql';
import Illustration from './assets/SuccessCheckConfettis.svg';
import locales from './locales';

interface SuccessProps {
  moduleData: GetEpAgreementWallContextQuery;
  onNext: () => void;
}

const Success = asBentoPage<SuccessProps>(({ Layout, moduleData, onNext }) => (
  <Layout>
    <Center flexDirection="column" marginTop="space-32">
      <Image marginBottom="space-40" src={Illustration} />

      <Heading>
        {locales.formatString(locales.title, {
          firstName: moduleData.viewer.profile.firstName || '',
        })}
      </Heading>

      <Text>{locales.description}</Text>

      <Button marginTop="space-40" onClick={onNext}>
        {locales.cta}
      </Button>
    </Center>
  </Layout>
));

export default Success;
